import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'
// import FormCustomerImages from './FormCustomers__Images'

function FormCustomers__Details(props) {
    const { formik, customerGroups } = props

    return (
        <React.Fragment>

            {/* <AppFormikInputFieldRadio
                formik={formik}
                stFormClass={"st-form  st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Email Verified"}
                formikFieldName={"email_verified"}
            /> */}

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"First Name"}
                inputType={"text"}
                isRequired={true}
                placeholder={"First Name"}
                formikFieldName={"first_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Middle Name"}
                inputType={"text"}
                placeholder={"Middle Name"}
                formikFieldName={"middle_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Last Name"}
                inputType={"text"}
                isRequired={true}
                placeholder={"Last Name"}
                formikFieldName={"last_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Company Name"}
                inputType={"text"}
                isRequired={false}
                placeholder={"Company Name"}
                formikFieldName={"company_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Email"}
                inputType={"email"}
                isRequired={true}
                placeholder={"Email"}
                formikFieldName={"email"}
            />

            {/* <label className="st-switch-input d-inline-flex st-form">
                Allow remote shipping assistance
                <input type="checkbox" className="d-none" />

                <span className="round-outer ms-2">
                    <span className="round d-block"></span>
                </span>

                <span className="text ms-2 position-relative st-fs-13 st-fw-600">Yes</span>
            </label> */}

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Password"}
                isRequired={true}
                placeholder={"Password"}
                formikFieldName={"password"}
                inputType={"password"}
            />

            <AppFormikSelectInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Customer Group"}
                formikFieldName={"customer_group_id"}
            >
                <option value="" disabled>Select Customer Group</option>
                {(customerGroups && customerGroups.length) && customerGroups.map(item => (
                    <option
                        key={item.group_id.toString()}
                        value={item.group_id.toString()}
                    >{item.group_name}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                labelName={"Tax Id/EIN"}
                isRequired={false}
                placeholder={"XX-XXXXXXX"}
                inputType={"text"}
                formikFieldName={"license_number"}
                onChange={(e) => {
                    let value = e.target.value
                    value = value.replace(/[^0-9]/ig, '')
                    if (value.length > 10) {
                        value = value.slice(0, 10)
                    }

                    if (value.length > 2) {
                        const v = value
                        const p1 = value.slice(0, 2)
                        const p2 = v.slice(2, v.length)
                        value = p1 + "-" + p2
                    }
                    formik?.setFieldValue("license_number", value)
                }}
            />

            {/* 
            <div className={`st-form  st-form-with-label-left d-flex flex-wrap align-items-center ${(formik.touched.activate_net30 && formik.errors.activate_net30) ? "has-msg msg-error" : ""}`}>
                <label>Business License</label>
                <div className="media-body st-form-input-container align-left">

                    <FormCustomerImages />
                </div>
            </div> */}

        </React.Fragment>
    )
}

export default memo(FormCustomers__Details)